import { Component, OnDestroy, Input, TemplateRef, ContentChild } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';


@Component({
    selector: 'btn-cell-renderer-delete-clipboard',
    template: `
		<em *ngIf="enableDelete">
		<img [style]="pageName? 'margin-right: 10px;cursor:pointer;' : 'margin-right:16px;cursor:pointer;'"  
		style="cursor:pointer;"  src="./assets/images/delete_red.svg" 
		(click)="btnClickedHandler('delete')">
		</em>
		
		<em *ngIf="enableClipboard">
		<img style="cursor:pointer;" 
		src="./assets/images/clipboard_list_black.svg" 
		(click)="btnClickedHandler('clipboard')"> 
		</em>

		`,
    standalone: false
})
export class BtnCellRendererDeleteClipboard implements ICellRendererAngularComp, OnDestroy {



	refresh(params: ICellRendererParams): boolean {
		throw new Error(`Error while refreshing renderer component. INFO-${params}`);
	}

	private params: any;
	pageName;
	enableClipboard: boolean = false;
	enableDelete: boolean = false;

	agInit(params: any): void {
		this.params = params;
		this.pageName = this.params.colDef.field;

		//history
		if (this.params.colDef.field == "history_deleteclipboard") {  // NOSONAR
			this.enableClipboard = true;
			this.enableDelete = true;
		}

	}

	btnClickedHandler(action) {

		if (action == 'delete') {  // NOSONAR
			this.params.context.componentParent.deleteTemplateRow(this.params.data, this.pageName);
		}
		else if (action == 'clipboard') {  // NOSONAR
			this.params.context.componentParent.clipboardTemplateRow(this.params.data, this.pageName);
		}
	}

	ngOnDestroy() {
console.info()


	}
}
